import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  error: "",
  loading: false,
  errorMsg: false,
};

const setPasswordSlice = createSlice({
  name: "setPassword",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error =
        action.payload.message === "Unauthorized"
          ? "Invalid or expired token"
          : action.payload.message;
      state.loading = false;
      state.errorMsg = true;
    },
    setPasswordSuccess(state, action) {
      state.user = action.payload.data;
      state.loading = false;
      state.errorMsg = false;
    },
    reset_set_password_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
  },
});

export const { apiError, setPasswordSuccess, reset_set_password_flag } =
  setPasswordSlice.actions;

export default setPasswordSlice.reducer;
